import { TeamMemberReference } from './TeamMemberStore';
import {
  types,
  Instance,
  SnapshotIn,
  SnapshotOut,
  flow,
} from 'mobx-state-tree';
import { DateTime } from './DateTime';
import { modelWithCRUD } from './utils/modelWithCRUD';

export const Invitation = types.model('Invitation', {
  id: types.union(types.identifier, types.identifierNumber),
  key: types.string,
  created_at: DateTime,
  sent: types.maybeNull(DateTime),
  email: types.string,
  key_expired: types.boolean,
  inviter: types.late(() => TeamMemberReference),
});

export const InvitationStore = modelWithCRUD('invitations', Invitation).actions(
  (self) => ({
    resendInvite: flow(function* resendInvite(invite: IInvitation) {
      const { data } = yield self.env.api.post(
        `${self.apiPath}/${invite.id}/resend/`,
        {}
      );
      self.putItem(data);
      return Invitation;
    }),
  })
);

export interface IInvitation extends Instance<typeof Invitation> {}
export interface IInvitationSnapshotIn extends SnapshotIn<typeof Invitation> {}
export interface IInvitationSnapshotOut
  extends SnapshotOut<typeof Invitation> {}
